<script setup>
import {computed, ref, watch} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useModalsStore} from '@/stores/modals'
import {useItemDataStore} from '@/stores/itemData'
import FormControlCategoryTitle from '@/common/form-control/FormControlCategoryTitle.vue'

const props = defineProps({
    field: Object,
    item: Object
})

const componentsStore = useComponentsStore()
const modalsStore = useModalsStore()
const itemDataStore = useItemDataStore()

const content = ref(null)

watch(
    () => props.item.contentId,
    async (newContentId) => {
        if (!newContentId) {
            content.value = null
            return
        }
        content.value = await itemDataStore.get({
            tableName: 'content',
            id: newContentId
        })
    },
    {immediate: true}
)

const contentType = ref(null)

watch(
    content,
    async (newContent) => {
        if (!newContent) {
            contentType.value = null
            return
        }
        contentType.value = await itemDataStore.get({
            tableName: 'templates_templates',
            id: newContent.contentType
        })
    },
    {immediate: true}
)

const componentId = computed(() => contentType.value?.componentId)

const tableName = computed(() => {
    const targetId = props.item.fieldId === null ? componentId.value : props.field?.categoryComponentId
    return componentsStore.items.find(o => o.id === targetId)?.tableName
})

const itemId = computed(() => parseInt(props.item.value))

const show = computed(() => ['is associated to', 'is not associated to'].includes(props.item.operator))

const selectCategory = async () => {
    const modalObj = await modalsStore.show({
        componentName: 'SelectListModal',
        obj: {
            listingName: `${tableName.value}.${props.item.fieldId}`,
            selectedIds: itemId.value ? [itemId.value] : [],
            onSelect: (selectedIds) => {
                props.item.value = selectedIds.pop()
                if (modalObj?.id !== undefined) {
                    modalsStore.remove(modalObj.id)
                }
            }
        }
    })
}
</script>

<template>
    <button
        v-if="show && tableName"
        class="btn btn-sm btn-light text-start"
        type="button"
        @click="selectCategory"
    >
        <span v-if="!item.value">select</span>
        <FormControlCategoryTitle v-if="itemId" :table-name="tableName" :id="itemId"/>
    </button>

    <small v-else-if="show && !componentId" class="text-danger form-text ms-2 mb-1 fst-italic small">
        Error: No collection targeted
    </small>
</template>